import React from "react";
import './../styles/default.css';
import NavbarTop from './default/Navbartop';
import Banner from './default/Banner';
import Footer from './default/Footer';

const Terminos = () => {
    return (
        <>
            <div className="app-default app-container">
                <NavbarTop />
                <div className="main-content page-terminos-condiciones">
                    <div className="page-container">
                        <Banner src="/imagenes/terminos-y-condiciones/banner1.webp" type="imagen" overlay="gradient">
                            <h1 className="text-white">Términos y condiciones de uso</h1>
                        </Banner>

                        <div className="container-section section flex-column gap-40">
                            <div className="flex-column gap-10">
                                <h3>1. Aceptación de los términos</h3>
                                <p>Al utilizar Don Honesto, aceptas estos términos y condiciones. Si no estás de acuerdo, por favor no uses el sitio ni nuestros servicios.</p>
                            </div>

                            <div className="flex-column gap-10">
                                <h3>2. Sobre la plataforma </h3>
                                <p>Don Honesto es un intermediario entre personas que buscan servicios para el hogar o profesionales, y trabajadores que ofrecen dichos servicios. No garantizamos el desempeño individual de los profesionales, pero buscamos garantizar calidad mediante filtros, evaluaciones y supervisión.</p>
                            </div>

                            <div className="flex-column gap-10">
                                <h3>3. Registro y cuentas </h3>
                                <p>El usuario es responsable de proporcionar información veraz y mantener la confidencialidad de sus datos de acceso. Está prohibido usar identidades falsas o suplantar a otras personas. </p>
                            </div>

                            <div className="flex-column gap-10">
                                <h3>4. Pagos y comisiones</h3>
                                <p>Los pagos se realizan a través de la plataforma. El dinero se libera al profesional una vez que el servicio ha sido confirmado como satisfactorio. Don Honesto retiene una comisión previamente establecida y ofrece membresías opcionales para los profesionales.</p>
                            </div>

                            <div className="flex-column gap-10">
                                <h3>5. Responsabilidad</h3>
                                <p>Don Honesto no se hace responsable por daños, pérdidas o perjuicios derivados del uso del sitio o de los servicios entre usuarios, aunque tomará medidas razonables para garantizar la seguridad y calidad del servicio.</p>
                            </div>

                            <div className="flex-column gap-10">
                                <h3>6. Propiedad intelectual </h3>
                                <p>Todo el contenido, logo y diseño de Don Honesto es propiedad exclusiva de la plataforma. Está prohibida su reproducción sin autorización escrita.</p>
                            </div>

                            <div className="flex-column gap-10">
                                <h3>7. Modificaciones</h3>
                                <p>Nos reservamos el derecho de modificar estos términos en cualquier momento. Las modificaciones serán visibles en esta sección y se considerarán aceptadas por el uso continuo de la plataforma.</p>
                            </div>

                            <div className="flex-column gap-10">
                                <h3>8. Legislación aplicable </h3>
                                <p>Este sitio opera bajo las leyes de los Estados Unidos Mexicanos. En caso de controversia, las partes se someten a las leyes y tribunales competentes de Guadalajara, Jalisco.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
};

export default Terminos;